import { supabase } from "./dataService";
import { createPurchaseDraftSnapshot } from "../utils/purchaseDraft";

const draftServiceError = (message) => {
  const error = new Error(message);
  error.response = { data: { error: message } };
  return error;
};

const throwDraftError = (error, operation) => {
  if (error?.code === "42501") {
    throw draftServiceError("Administrator access is required.");
  }
  const messages = {
    load: "The saved purchase draft could not be loaded.",
    save: "The purchase draft could not be saved to the server.",
    delete: "The saved purchase draft could not be deleted.",
  };
  throw draftServiceError(messages[operation]);
};

const normalizeRemoteDraft = (data) => {
  if (!data) return null;
  return createPurchaseDraftSnapshot({
    supplierId: data.supplierId ?? data.supplier_id ?? "",
    submissionKey: data.submissionKey ?? data.submission_key,
    lines: data.lines || [],
    updatedAt: data.updatedAt ?? data.updated_at,
  });
};

export async function getPurchaseDraft() {
  const { data, error } = await supabase.rpc("get_purchase_draft");
  if (error) throwDraftError(error, "load");
  return normalizeRemoteDraft(data);
}

export async function savePurchaseDraft(snapshot) {
  const supplierId = String(snapshot?.supplierId || "").trim();
  const { data, error } = await supabase.rpc("save_purchase_draft", {
    p_supplier_id: supplierId ? Number(supplierId) : null,
    p_submission_key: snapshot.submissionKey,
    p_lines: snapshot.lines || [],
  });
  if (error) throwDraftError(error, "save");
  return normalizeRemoteDraft(data);
}

export async function deletePurchaseDraft() {
  const { data, error } = await supabase.rpc("delete_purchase_draft");
  if (error) throwDraftError(error, "delete");
  return Boolean(data);
}
